<template>
  <div class="payment-method-wrapper">
    <p class="title">{{$t('400125')}}</p>
    <div class="select-wrapper" v-if="payments.length">
      <el-select
        v-model="payment"
        :placeholder="$t('400149')"
        clearable
        :popper-append-to-body="false"
      >
        <el-option
          class="fiat-wrapper"
          v-for="item in payments"
          :value="item.value"
          :label="item.label | upcase"
          :key="item.value"
        ></el-option>
        <a class="more el-select" @click="gotoUsercenter">{{$t('400127')}}</a>
      </el-select>
    </div>
    <div v-else>
      <el-button
        @click="gotoUsercenter"
        class="set-payment"
        type="default"
        plain
        >{{$t('400126')}}</el-button
      >
    </div>
  </div>
</template>
<script>
import { paymentOptional } from "../../api";
import {mapGetters} from "vuex";

export default {
  props: {},
  data() {
    return {
      set: false,
      defaultValue: "",
      payment: "",
      payments: [],
    };
  },
  computed: {
    ...mapGetters(['token'])
  },
  created() {
    if (this.token){
      this.paymentOptional();
    }
  },
  watch: {
    payment(v) {
      this.$emit("getPayment", v);
    },
  },
  methods: {
    // 跳转去设置收款方式
    gotoUsercenter() {
      this.$router.push("/usercenter");
    },
    // 获取收款方式
    async paymentOptional() {
      const resOp = await paymentOptional();
      this.payments = resOp.map((i) => ({
        label: i.paymentName + " " + i.detail[0].account,
        value: i.detail?.[0].id,
      }));
    },
  },
};
</script>
<style lang="scss" scoped>
.more {
  text-align: center;
  color: #ffc72b;
  text-decoration: underline;
  vertical-align: center;
  cursor: pointer;
  line-height: 40px;
  height: 40px;
}
.el-select {
  width: 100%;
}

.select-wrapper,
.set-payment {
  margin-bottom: 24px;
}
.set-payment {
  width: 100%;
  color: #ffc72b;
}
.payment-method-wrapper {
  text-align: left;
  .title {
    height: 14px;
    font-size: 14px;
    font-family: Lato-Regular, Lato;
    font-weight: 400;
    color: #7f8490;
    line-height: 14px;
    margin-top: 24px;
    margin-bottom: 10px;
  }
}
</style>
